import { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
import { useState, useEffect } from "react";
// material
import { useTheme, styled } from "@mui/material/styles";
import { Card, CardHeader, Stack, Box, Container, CircularProgress } from "@mui/material";
// utils
import { findNextMultipleOf1000, fNumber } from "../../../utils/formatNumber";
//
import { BaseOptionChart } from "../../charts";

// ----------------------------------------------------------------------

function AppTypes(props) {
  const CHART_DATATypes = [
    {
      data:
        props.icpc_consultation.icpc_counts &&
        props.icpc_consultation.icpc_counts.map((count) => parseInt(count)),
    },
  ];
  const [prescXaxis, setPrescXaxis] = useState(0);
  const [refreshGraph, setRefreshGraph] = useState(false);

  useEffect(() => {
    if (props.icpc_consultation && props.icpc_consultation !== undefined) {
      setRefreshGraph((prev) => !prev);
    }
  }, [props.icpc_consultation]);

  useEffect(() => {
    if (props.icpc_consultation && props.icpc_consultation.icpc_counts) {
      const maxVal = Math.max(...props.icpc_consultation.icpc_counts);
      const add20Percent = maxVal + maxVal * 0.2;
      let maxX = 0;
      if (add20Percent < 200) {
        maxX = Math.ceil(add20Percent / 100) * 100;
      } else if (add20Percent < 500) {
        maxX = Math.ceil(add20Percent / 500) * 500;
      } else {
        maxX = findNextMultipleOf1000(add20Percent);
      }
      setPrescXaxis(maxX);
    }
  }, [props.icpc_consultation]);
  const chartOptions_TypesBar = merge(BaseOptionChart(), {
    tooltip: {
      marker: { show: false },
      followCursor: true,
      x: {
        show: true,
        // format: 'dd MMM',
        formatter: undefined,
        title: {
          formatter: (seriesName) => seriesName,
        },
      },
      y: {
        formatter: function (val, opt) {
          const total = CHART_DATATypes[0].data.reduce(
            (acc, curr) => acc + curr,
            0
          );
          const percentage = ((val / total) * 100).toFixed(0);
          return `${percentage}%`;
        },
        title: {
          formatter: (seriesName) => `Percentage of all consultations: `,
        },
      },
    },
    grid: {
      borderColor: "transparent",
      row: {
        colors: ["transparent"], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    colors: ["#3E8397"],
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: "top",
        },
        columnWidth: "60%",
        distributed: false,
      },
    },
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      formatter: function (val, opt) {
        const label_value = fNumber(val);
        return label_value;
      },
      enabled: true,
      style: {
        colors: ["#708090"],
      },
      offsetX: 35,
    },
    xaxis: {
      categories: props.icpc_consultation.icpc_descriptions
        ? props.icpc_consultation.icpc_descriptions.map((desc) => {
            if (desc.toLowerCase() === "copd") {
              return "COPD";
            }
            return desc.charAt(0).toUpperCase() + desc.slice(1);
          })
        : null,
      show: true,
      min: 0,
      max: prescXaxis,
      tickAmount: 5,
      labels: {
        show: true,
        style: {
          colors: "#808080",
        },
      },
      // position: 'top',
    },
    yaxis: {
      show: true,
      labels: {
        show: true,
        style: {
          colors: "#22577A",
        },
      },
    },
    stroke: {
      show: false,
    },
  });

  if (props.loading) {
    return (
      <Container 
      sx={{
        height: 'auto',
        minHeight: 250,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingTop: 10,
        alignItems: 'center',
      }}>
        <CircularProgress
          style={{
            marginTop: '20px',
            alignSelf: 'center',
          }}
        />
      </Container>
    );
  }

  return (
    <Card sx={{ boxShadow: "none", mt: 4 }}>
      <Box sx={{ mx: 1 }} dir="ltr">
        <ReactApexChart
          type="bar"
          series={CHART_DATATypes}
          options={chartOptions_TypesBar}
          height={364}
          key={refreshGraph}
        />
      </Box>
    </Card>
  );
}
import { connect } from "react-redux";
const mapState = (state) => ({
  loading: state.overview.loading7,
  icpc_consultation: state.overview.icpc_consultation,
});

const mapDispatch = ({ overview: { loadData } }) => ({
  loadData: () => loadData(),
});

export default connect(mapState, mapDispatch)(AppTypes);
